<script setup lang="ts">
import { FieldNodePageFieldSidebarWidgets } from '~/api/graphql/generated'

const props = defineProps<{
  sidebar?: FieldNodePageFieldSidebarWidgets[]
  inFlow?: boolean
}>()

const slots = useSlots()
const sections = useSidebarSections(props.sidebar)
const shouldDisplay = computed(() => {
  return sections.length > 0 || slots.default?.()
})
</script>

<template>
  <Section v-if="shouldDisplay" v-animate="{ cluster: true }" :class="{ 'in-flow': inFlow }">
    <div class="sidebar t-10 t-o-1 tl-4">
      <div class="sidebar-content">
        <component
          :is="section?.name"
          v-for="(section, index) in sections"
          :key="`${section?.name}-${index}`"
          :entity="section.entity"
        />
        <slot />
      </div>
    </div>
  </Section>
</template>

<style scoped lang="scss">
.section-sidebar {
  @include fluid(--margin, 96px, 128px);
  @include breakpoint(tl) {
    margin-bottom: 0;
  }
  + :deep(.section) {
    margin-top: 0;
    // @include fluid(--margin, 96px, 128px);
  }
}
.section-sidebar.in-flow {
  @include breakpoint(tl) {
    // The section is a full-width overlay layer on event pages; only the actual
    // sidebar box may capture pointer events, the rest must click through to the
    // text layer underneath.
    pointer-events: none;

    .sidebar-content {
      position: static;
      pointer-events: auto;
    }
  }
}
.sidebar {
  position: relative;
  @include breakpoint(tl) {
    --offset: 8;
  }

  &-content {
    display: flex;
    flex-direction: column;
    gap: 35px;

    @include breakpoint(tl) {
      position: absolute;
      gap: 50px;
    }
  }
}

.sidebar-content {
  width: 100%;
  @include breakpoint(tl) {
    padding-left: 48px;
  }
}
</style>
